import { render, staticRenderFns } from "./ListBlock.vue?vue&type=template&id=65dd7c9e&"
import script from "./ListBlock.vue?vue&type=script&lang=js&"
export * from "./ListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports